import React from 'react';
import Modal from 'ds/components/modal';
import { DeveloperFiltersState } from 'store/state/app';
import { useLocale } from 'locale';
import { FiltersInner } from 'screens/DeveloperPage/components/filters/FiltersInner';
import { makeCallAll } from 'components/filters/utils';
import { FiltersControls } from './FiltersControls';


interface FiltersModalProps {
  filters: DeveloperFiltersState;
  setFilters: (filters: DeveloperFiltersState) => void;
  onSubmit: () => void;
  onClear: () => void;
  onClose: () => void;
  closeModal: () => void;
}

const FiltersModal: React.FC<FiltersModalProps> = (props) => {
  const { onClose, filters, setFilters, onClear, onSubmit, closeModal } = props;
  const { t } = useLocale();
  return (
    <Modal
      isOpen
      onClose={makeCallAll(closeModal, onClose)}
      buttons={<FiltersControls onClear={onClear} onSubmit={onSubmit} onClose={closeModal} />}
      title={t('developerPage.filters.modal.title')}
      isFullWidthMainContent
    >
      <FiltersInner filters={filters} setFilters={setFilters} />
    </Modal>
  );
};

export default FiltersModal;
